import React, { useState, useEffect } from "react";
import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap";
import api from "../../../apis/api";
import useFormValidation from "../../common/useFormValidation";
import Moment from 'moment';
import { connect } from "react-redux";
import Select from "react-select";
import "../../../style/employee.css"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import "../../../style/loginicon.css";
const eye = <FontAwesomeIcon icon={faEye} />;
const EmployeeEditForm = React.memo((props) => {
  const {
    selectedEmployee,
    designations,
    qualification,
    departments,
    officeLocationList,
    workPrimisesList,
    employeetypesList,
    getEmpList,
    shiftList,
    AllempList
  } = props;
  const [id, setId] = useState(0);
  const [employeeName, setEmployeeName] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [employeeType, setEmployeeType] = useState(0);
  const [primaryMailId, setPrimaryMailId] = useState("");
  const [altMailId, setAltMailId] = useState("");
  const [qualificationId, setQualificationId] = useState("");
  const [designationId, setDesignationId] = useState("");
  const [guardainName, setGuardainName] = useState("");
  const [bloodGrp, setBloodGrp] = useState("");
  const [mobileNumber, setModileNumber] = useState("");
  const [alternativeNo, setAlternativeNo] = useState("");
  const [dateOfJoin, setDateOfJoin] = useState(new Date());
  const [dateOfConfirmed, setDateOfConfirmed] = useState(new Date());
  const [dateOfResigned, setDateOfResigned] = useState("");
  const [dateOFBirth, setDateOfBirth] = useState(new Date());
  const [profilePicture, setProfilePicture] = useState("");
  const [postalAddress, setPostalAddress] = useState("");
  const [aadharNo, setAadharNo] = useState("");
  const [panNo, setPanNo] = useState("");
  const [esiNo, setEsiNo] = useState("");
  const [epfUan, setEpfUan] = useState("");
  const [accNo, setAccNo] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  const [skill, setSkill] = useState("");
  const [officeLocation, setOfficeLocation] = useState("");
  const [shifts, setShifts] = useState("");
  const [employee, setEmployee] = useState("");
   const [employeecode, setEmployeeCode] = useState("");
  const [workPrimise, setWorkPrimise] = useState("");  
  const [password, setPassword] = useState("");
  const [username, setUserName] = useState("");
  const [usernameCheck, setCheckStatus] = useState("");
  const[empList,setEmplList] = useState(getEmpList);
  const [employeeFormValidation, setEmployeeFormValidation] = useState({});
  const [error, setError] = useState(null);
  const [isRevealPwd, setIsRevealPwd] = useState(false);
  const [isResigned,setIsResigned]=useState(false);
  const [gender, setgender] = useState("");
  const [isclientholiday,setisclientholiday]= useState(false);
  const { formValidation, isFormValid } = useFormValidation(
    employeeFormValidation
  );
 let employeetypenewlist=[];
 if(employeetypesList.length >0)
    {
      employeetypesList.map((el,i) =>{
        employeetypenewlist.push({value :el.employeeTypeId ,label:el.employeeTypeValue})
      
      })
    }
    let qualificationlist=[];
    if(qualification.length >0)
    {
      qualification.map((el,i) =>{
        qualificationlist.push({value :el.qualificationId ,label:el.qualificationName})
      
      })
    }
    let designationsList=[];
    if(designations.length >0)
    {
      designations.map((el,i) =>{
        designationsList.push({value :el.designationId ,label:el.designationName})
      
      })
    }
    let departmentsList=[];
    if(departments.length >0)
    {
      departments.map((el,i) =>{
        departmentsList.push({value :el.departmentId ,label:el.departmentName})
      
      })
    }
    let officeLocationNewList=[];
    if(officeLocationList.length >0)
    {
      officeLocationList.map((el,i) =>{
        officeLocationNewList.push({value :el.officeLocationId ,label:el.address})
      
      })
    }
    let workPrimisesNedwList=[];
    if(workPrimisesList.length >0)
    {
      workPrimisesList.map((el,i) =>{
        workPrimisesNedwList.push({value :el.workingPremiseId ,label:el.workingPremiseType})
      
      })
    }
    let shiftListList=[];
    //shiftList
    if(shiftList.length >0)
    {
      shiftList.map((el,i) =>{
        shiftListList.push({value :el.shiftId ,label:el.shiftName})
      
      })
    }
    let AllempNewList =[];
    //AllempList
    if(AllempList.length >0)
    {
      AllempList.map((el,i) =>{
        AllempNewList.push({value :el.empId ,label:el.label})
      
      })
    }
  useEffect(() => {
    // calls handleAddForm() , ie after fomValidation changes by sumibiting the form
    handleAddForm();
    getEmpList();
  }, [formValidation]);
 
  const formValidationOnSubmit = () => {
    let formValidationList = {
      employeeName: {
        required: true,
        isValid: true,
        value: String(employeeName),
        errorMessage: "",
      },
 
      employeecode:{
        required: true,
        isValid: true,
        value: employeecode,
        errorMessage: "",
      },
      employeeType: {
        required: true,
        isValid: true,
        value: employeeType === 0 ? '' :employeeType,
        errorMessage: "",
      },
      qualification: {
        required: true,
        isValid: true,
        value: qualificationId===0 ?'' :qualificationId,
        errorMessage: "",
      },
      designation: {
        required: true,
        isValid: true,
        value: designationId === 0 ?'':designationId,
        errorMessage: "",
      },
      department: {
        required: true,
        isValid: true,
        value: departmentName === 0? '' :departmentName,
        errorMessage: "",
      },
      officeLocation: {
        required: true,
        isValid: true,
        value: officeLocation === 0? '' :officeLocation,
        errorMessage: "",
      },
      workPremise: {
        required: true,
        isValid: true,
        value: workPrimise === 0 ? '' : workPrimise,
        errorMessage: "",
      },
      shifts: {
        required: true,
        isValid: true,
        value: shifts === 0 ? '' : shifts,
        errorMessage: "",
      },
      primaryMailId: {
        required: true,
        isValid: true,
        value: checkEmailData(primaryMailId),
        errorMessage: "",
      },
      employee :{
        required: true,
        isValid: true,
        value: employee === 0 ? '' :employee,
        errorMessage: "",
      },
      username: {
        required: true,
        isValid: true,
        value: username,
        errorMessage: "",
      },
      password: {
        required: true,
        isValid: true,
        value: password,
        errorMessage: "",
      },
      gender: {
        required: true,
        isValid: true,
        value: gender,
        errorMessage: "",
      },
    };
    setEmployeeFormValidation(formValidationList); //this set call the custom hook useFormValidation.
  };
  const checkEmailData = (email)=>{
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if ( re.test(email) ) {
       return email;
    }
    else {
        return("");
    }
  }
  const handleAddForm = () => {
    // check whether the form is valid.
 if (isFormValid) {
          setCheckStatus("");
          const firstName = employeeName.split(" ")[0];
          let empFormData = new FormData();
          empFormData.append("employeeId", id);
          empFormData.append("employeeCode", parseInt(employeecode));
          empFormData.append("employeeType", parseInt(employeeType.value));
          empFormData.append("employeeName", employeeName);
          empFormData.append("dateOfJoin", dateOfJoin);
          empFormData.append("dateOFBirth", dateOFBirth);
          empFormData.append("aadharNumber", aadharNo);
          empFormData.append("panNumber", panNo);
          empFormData.append("esiNumber", esiNo);
          empFormData.append("epfuan", epfUan);
          empFormData.append("qualificationId", parseInt(qualificationId.value));
          empFormData.append("departmentId", parseInt(departmentName.value));
          empFormData.append("designationId", parseInt(designationId.value));
          empFormData.append(
            "designationName",
            designations.map((desg) =>
              desg.designationId === parseInt(designationId.value)
                ? desg.designationName
                : ""
            )[0]
          );
          empFormData.append("guardianName", guardainName);
          empFormData.append("postalAddress", postalAddress);
          empFormData.append("mobileNumber", mobileNumber);
          empFormData.append("emergencyNumber", alternativeNo);
          empFormData.append("primaryMailId", primaryMailId);
          empFormData.append("secondaryMailId", altMailId);
          empFormData.append("ifscCode", ifscCode);
          empFormData.append("bankAccountNumber", accNo);
          empFormData.append("bloodGroup", bloodGrp);
          empFormData.append("officeLocationId", parseInt(officeLocation.value));
          empFormData.append("workingPremiseId", parseInt(workPrimise.value));
          empFormData.append(
            "profilePicture",
            profilePicture === "" ? "user.png" : profilePicture
          );
          empFormData.append("createdDate", new Date());
          empFormData.append("createdBy", 1);
          empFormData.append("modifiedDate", "2020-06-09T07:25:27.612Z");
          empFormData.append("modifiedBy", 0);
          empFormData.append("isActive", isResigned ==true ? false : true);
          empFormData.append("userName",username);
          empFormData.append("password", password);
          empFormData.append("roles", "string");
          empFormData.append("fileName", "string");
          empFormData.append("contentType", "string");
          empFormData.append("file", null);
          empFormData.append("isLatest", true);
          empFormData.append("encrptedPassword", firstName);
          empFormData.append("skills",String(skill));
          empFormData.append("shiftId",parseInt(shifts.value));
          empFormData.append("leaveAssignedEmpId",parseInt(employee.value));
          empFormData.append("confirmedDate",dateOfConfirmed);
          empFormData.append("resignedDate",dateOfResigned);
          empFormData.append("gender",gender);
          empFormData.append("isClientHoliday",isclientholiday);
          if (selectedEmployee) {
            props.handleUpdateEmp(empFormData);
          } else {
            props.handleAddEmp(empFormData);
          }
          props.toggle();
        
        }
       
  };

  //check username exists or not
  const checkUserName =async(username) => {
    setUserName(username);

    let checkusernameStatus = await api.dbEmployeeTypes().UserNameCheck(username);
    if (checkusernameStatus.status === 200) { 

      if(checkusernameStatus.data === 0){
        // setUserName(username);
        setCheckStatus("");
      }         
      else{
        setCheckStatus("exists");
        // setUserName(username);
      }    
    } else {
      setError({ ...error, message: "Bad Connection" });
    }
  };
const handleusername =(username) =>{
  setUserName(username);
}
  useEffect(() => {
    if (selectedEmployee) {

      //if an employeee is clicked for edit , the assigns its value to state.
      setEmplList(getEmpList);
      setId(selectedEmployee.employeeId);
      setgender(selectedEmployee.gender);
      const newt=selectedEmployee.resignedDate.substring(0, 10);
      setIsResigned(selectedEmployee.isActive == true ? false : true);
      setDateOfConfirmed(selectedEmployee.confirmedDate.substring(0, 10));
      setDateOfResigned(selectedEmployee.resignedDate.substring(0, 10));
      setEmployeeName(selectedEmployee.employeeName);
      setEmployeeId(selectedEmployee.employeeId=="null"?"":selectedEmployee.employeeId);
      setEmployeeType({value:selectedEmployee.employeeType,label:selectedEmployee.employeeTypeValue} );
      setPrimaryMailId(selectedEmployee.primaryMailId=="null"?"":selectedEmployee.primaryMailId);
      setAltMailId(selectedEmployee.secondaryMailId=="null"?"":selectedEmployee.secondaryMailId);
      setQualificationId({value:selectedEmployee.qualificationId,label:selectedEmployee.qualificationName});
      setDesignationId({value:selectedEmployee.designationId,label:selectedEmployee.designationName});
      setGuardainName(selectedEmployee.guardianName=="null"?"":selectedEmployee.guardianName);
      setBloodGrp(selectedEmployee.bloodGroup=="null"?"":selectedEmployee.bloodGroup);
      setModileNumber(selectedEmployee.mobileNumber=="null"?"":selectedEmployee.mobileNumber);
      setAlternativeNo(selectedEmployee.emergencyNumber=="null"?"":selectedEmployee.emergencyNumber);
      setDateOfJoin(selectedEmployee.dateOfJoin.substring(0, 10));
      setDateOfBirth(selectedEmployee.dateOFBirth.substring(0, 10));
      setPostalAddress(selectedEmployee.postalAddress=="null"?"":selectedEmployee.postalAddress);
      setAadharNo(selectedEmployee.aadharNumber=="null"?"":selectedEmployee.aadharNumber);
      setPanNo(selectedEmployee.panNumber=="null"?"":selectedEmployee.panNumber);
      setEsiNo(selectedEmployee.esiNumber=="null"?"":selectedEmployee.esiNumber);
      setEpfUan(selectedEmployee.epfuan=="null"?"":selectedEmployee.epfuan);
      setAccNo(selectedEmployee.bankAccountNumber=="null"?"":selectedEmployee.bankAccountNumber);
      setIfscCode(selectedEmployee.ifscCode=="null"?"":selectedEmployee.ifscCode);
      setProfilePicture(selectedEmployee.profilePicture);

      setDepartmentName({value:selectedEmployee.departmentId,label:selectedEmployee.departmentName});
      setOfficeLocation({value:selectedEmployee.officeLocationId,label:selectedEmployee.postalAddress});
      setShifts({value:selectedEmployee.shiftId,label:selectedEmployee.shiftName});
      setWorkPrimise({value:selectedEmployee.workingPremiseId,label:selectedEmployee.workingPremiseType});
      setUserName(selectedEmployee.userName);
      setPassword(selectedEmployee.encrptedPassword);
      setSkill(selectedEmployee.skills);
      setShifts({value:selectedEmployee.shiftId,label:selectedEmployee.shiftName});
      setEmployee({value:selectedEmployee.leaveAssignedEmpId,label:selectedEmployee.leaveAssignedName});
      setEmployeeCode(selectedEmployee.employeeCode);
      setisclientholiday(selectedEmployee.isClientHoliday);
    } else {
      //if add btn click then keep the state to null,
      //cuz when editClick and then addClicked then last value remains in state.
      setId(0);      
      setEmplList(getEmpList);
      setPrimaryMailId("");
      setQualificationId(0);
      setDesignationId(0);
      setDepartmentName(0);
      setOfficeLocation(0);
      setWorkPrimise(0);
      setEmployeeName("");
      setEmployeeId("");
      setEmployeeType(0);
      setDateOfJoin(new Date());
      setDateOfBirth(new Date());
      setUserName("");
      setPassword("");
      setPostalAddress("");
      setAlternativeNo("");
      setAltMailId("");
      setModileNumber("");
      setSkill("");
      setShifts("");
      setEmployee("");
      setgender("");
      setDateOfConfirmed("");
      setDateOfResigned("");
      setEmployeeCode("");
      setisclientholiday(false);
    }
  }, [selectedEmployee]);

  const handleChangeValidationText=(text)=>{
    const result =text.replace(/[^a-z ]/gi, '');
    setEmployeeName(result);
  }
  const handleChangePrimaryNumber=(data)=>{  
    const result =data.replace(/[^0-9+]*/gi,'');
    setModileNumber(result)
  }
  const handleChangeSecNumber=(data)=>{  
    const result =data.replace(/[^0-9+]*/gi,'');
    setAlternativeNo(result)
  }
  const handleChangeAccNumber=(data)=>{  
    const result =data.replace(/[^0-9]*/gi,'');
    setAccNo(result)
  }
  const togglecancel = () =>{
    setEmployeeType("");
    props.toggle();
  }
  const togglePasswordVisiblity = () => {
    setIsRevealPwd(prevState => !prevState);
  };
  const handleresigned =React.useCallback((val) =>{
    setIsResigned(val);
    if(val == false)
    {
      setDateOfResigned("");
    }
  },[setIsResigned])
  return (
    <Form>   
      <Row>
        <Col>
        <h3>Employee</h3> 
        </Col>
        </Row>  
      <Row form>
        <Col md={6}>
          <FormGroup>
            <Label>Employee Name <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
            <Input
              type="Text"
              name="EmployeeName"
              onChange={(e) => {
                handleChangeValidationText(e.target.value);
                
                // setSetateNameForValidation("employeeName");
                // setValuesForValidation(e.target.value);
                // formValidation("employeeName", e.target.value);
              }}
              value={employeeName}
            />
            {/* when there is entry in FormValidation only render condition loop */}
            {/* */}
            {Object.keys(formValidation).length !== 0 &&
              !formValidation.employeeName.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.employeeName.errorMessage}
                </span>
              )}
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Employee Code <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
            <Input
              type="Text"
              name="employeecode"
              onChange={(e) => setEmployeeCode(e.target.value)}
              value={employeecode}
            />
            {/* when there is entry in FormValidation only render condition loop */}
            {Object.keys(formValidation).length !== 0 &&
              !formValidation.employeecode.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.employeecode.errorMessage}
                </span>
              )}
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Employee Type <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
            {/* <Input
              type="select"
              onChange={(e) => setEmployeeType(e.target.value)}
            >
              <option value="">Select Employee Type</option>
              {employeetypesList.map((employeeTypeEl, i) => (
                <option
                  value={employeeTypeEl.employeeTypeId}
                  selected={
                    employeeType === employeeTypeEl.employeeTypeId
                      ? true
                      : false
                  }
                >
                  {employeeTypeEl.employeeTypeValue}
                </option>
              ))}
            </Input> */}
              <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={employeetypenewlist[0]}
        onChange={(e) => {
           setEmployeeType({value :e.value, label :e.label});
        }} 
        value={employeeType}
        isSearchable={true}
        name="color"
        options={employeetypenewlist}
      />
            {/* when there is entry in FormValidation only render condition loop */}
            {Object.keys(formValidation).length !== 0 &&
              !formValidation.employeeType.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.employeeType.errorMessage}
                </span>
              )}
          </FormGroup>
        </Col>
      </Row>
      <Row form>
        <Col md={4}>
          <FormGroup>
            <Label> Gender <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
            <Input type="select" onChange={(e) => setgender(e.target.value)}>
                  <option value="Select">Select</option>
                  <option value="Male" selected={gender=="Male" ? true : false}>Male</option>
                  <option value="Female" selected={gender=="Female" ? true : false}>Female</option>
                </Input>
                {Object.keys(formValidation).length !== 0 &&
              !formValidation.gender.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.gender.errorMessage}
                </span>
              )}
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label> ConfirmedOn </Label>
            <Input
              type="date"
              onChange={(e) => setDateOfConfirmed(e.target.value)}
              // value={"2013-01-08"}

              value={dateOfConfirmed === '0001-01-01' ? "" :dateOfConfirmed}
              max={Moment().format("YYYY-MM-DD")}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label> Resigned</Label>
            <Input
                   className="calendaryearcheckboxedit"
                 
                  // style="margin-left: -126px !important;margin-top: 13px;"
                     type="checkbox"
                     onChange={(e) => {
                      handleresigned(e.target.checked);
                     }} 
                     checked={isResigned}
               
                     value={isResigned}  
                   />
                   <Input
              type="date"
              onChange={(e) => setDateOfResigned(e.target.value)}
              // value={"2013-01-08"}

              value={dateOfResigned === '0001-01-01' ? "" :dateOfResigned}
              max={Moment().format("YYYY-MM-DD")}
            />
          </FormGroup>
        </Col>
       
      </Row>
      <Row form>
        <Col md={6}>
          <FormGroup>
            <Label> Primary Mail Id <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
            <Input
              type="Text"
              name="primaryMailId"
              onChange={(e) => {

                setPrimaryMailId(e.target.value);
              }}
              value={primaryMailId}
              />
              {/* when there is entry in FormValidation only render condition loop */}
              {Object.keys(formValidation).length !== 0 &&
              !formValidation.primaryMailId.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.primaryMailId.errorMessage}
                </span>
              )}
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label> Alternative Mail Id</Label>
            <Input
              type="Text"
              name="doj"
              onChange={(e) => setAltMailId(e.target.value)}
              value={altMailId}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row form>
        <Col md={3}>
          <FormGroup>
            <Label> Qualification <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
            {/* <Input
              type="select"
              onChange={(e) => setQualificationId(e.target.value)}
            >
              <option value="0">Select Qualification</option>
              {qualification.map((qualification, i) => (
                <option
                  value={qualification.qualificationId}
                  selected={
                    qualificationId === qualification.qualificationId
                      ? true
                      : false
                  }
                >
                  {qualification.qualificationName}
                </option>
              ))}
            </Input> */}
            <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={qualificationlist[0]}
        onChange={(e) => {
          setQualificationId({value :e.value, label :e.label});
        }} 
       value={qualificationId}
        isSearchable={true}
        name="color"
        options={qualificationlist}
      />
            {/* when there is entry in FormValidation only render condition loop */}
            {Object.keys(formValidation).length !== 0 &&
              !formValidation.qualification.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.qualification.errorMessage}
                </span>
              )}
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Designation <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
            {/* <Input
              type="select"
              onChange={(e) => setDesignationId(e.target.value)}
            >
              <option value="0">Select Designation</option>
              {designations.map((desigination, i) => (
                <option
                  value={desigination.designationId}
                  selected={
                    designationId === desigination.designationId ? true : false
                  }
                >
                  {desigination.designationName}
                </option>
              ))}
            </Input> */}
              <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={designationsList[0]}
        onChange={(e) => {
          setDesignationId({value :e.value, label :e.label});
        }} 
       value={designationId}
        isSearchable={true}
        name="color"
        options={designationsList}
      />
            {/* when there is entry in FormValidation only render condition loop */}
            {Object.keys(formValidation).length !== 0 &&
              !formValidation.designation.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.designation.errorMessage}
                </span>
              )}
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Guardian Name</Label>
            <Input
              type="Text"
              name="doj"
              onChange={(e) => setGuardainName(e.target.value)}
              value={guardainName}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Blood Group</Label>
            <Input
              type="Text"
              name="doj"
              onChange={(e) => setBloodGrp(e.target.value)}
              value={bloodGrp}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row form>
        <Col md={3}>
          <FormGroup>
            <Label>Mobile Number</Label>
            <Input
              type="Text"
              name="doj"
              onChange={(e) => handleChangePrimaryNumber(e.target.value)}
              value={mobileNumber}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Alternative Number</Label>
            <Input
              type="Text"
              name="dob"
              onChange={(e) => {handleChangeSecNumber(e.target.value);
              }}
              value={alternativeNo}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Date of Joining</Label>
            <Input
              type="date"
              onChange={(e) => setDateOfJoin(e.target.value)}
              // value={"2013-01-08"}

              value={dateOfJoin === '0001-01-01' ? "" :dateOfJoin}
              max={Moment().format("YYYY-MM-DD")}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Date of Birth</Label>
            <Input
              type="date"
              onChange={(e) => setDateOfBirth(e.target.value)}
              value={dateOFBirth === '0001-01-01' ? "" : dateOFBirth}
              max={Moment().format("YYYY-MM-DD")}
            />

            {/* <Input
              type="Text"
              name="dob"
              onChange={(e) => setDob(e.target.value)}
            /> */}
          </FormGroup>
        </Col>
      </Row>
      <Row form>
        <Col md={3}>
          <FormGroup>
            <Label>Profile Photo</Label>
            <Input
              type="file"
              name="file"
              onChange={(e) => setProfilePicture(e.target.files[0].name)}
            />
          </FormGroup>
        </Col>
        <Col md={9}>
          <FormGroup>
            <Label>Address</Label>
            <Input
              type="textarea"
              name="doj"
              onChange={(e) => setPostalAddress(e.target.value)}
              value={postalAddress}
            />
          </FormGroup>
        </Col>
      </Row>
      {/* </div> */}
      <hr></hr>
      <Row form>
        <Col md={6}>
          <FormGroup>
            <Label>Aadhar Number</Label>
            <Input
              type="Text"
              name="AadharNumber "
              onChange={(e) => setAadharNo(e.target.value)}
              value={aadharNo}
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>PAN Number </Label>
            <Input
              type="Text"
              name="panNo"
              onChange={(e) => setPanNo(e.target.value)}
              value={panNo}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row form>
        <Col md={6}>
          <FormGroup>
            <Label>ESI No</Label>
            <Input
              type="Text"
              name="esiNo"
              onChange={(e) => setEsiNo(e.target.value)}
              value={esiNo}
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>EPF UAN </Label>
            <Input
              type="Text"
              name="epfUan"
              onChange={(e) => setEpfUan(e.target.value)}
              value={epfUan}
            />
          </FormGroup>
        </Col>
      </Row>
      <hr></hr>
      <Row form>
        <Col md={6}>
          <FormGroup>
            <Label>Account Number </Label>
            <Input
              type="Text"
              onChange={(e) => handleChangeAccNumber(e.target.value)}
              value={accNo}
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>IFSC Code </Label>
            <Input
              type="Text"
              name="ifcs "
              onChange={(e) => setIfscCode(e.target.value)}
              value={ifscCode}
            />
          </FormGroup>
        </Col>
      </Row>
      <hr></hr>
      <Row form>
        <Col md={3}>
          <FormGroup>
            <Label>Department <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
            {/* <Input
              type="select"
              onChange={(e) => setDepartmentName(e.target.value)}
            >
              <option value="">Select Department</option>
              {departments.map((department, i) => (
                <option
                  value={department.departmentId}
                  selected={
                    departmentName === department.departmentId ? true : false
                  }
                >
                  {department.departmentName}
                </option>
              ))}
            </Input> */}
            <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={departmentsList[0]}
        onChange={(e) => {
          setDepartmentName({value :e.value, label :e.label});
        }} 
       value={departmentName}
        isSearchable={true}
        name="color"
        options={departmentsList}
      />
            {/* when there is entry in FormValidation only render condition loop */}
            {Object.keys(formValidation).length !== 0 &&
              !formValidation.department.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.department.errorMessage}
                </span>
              )}
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Skill </Label>
            <Input type="text" onChange={(e) => setSkill(e.target.value)} value={skill}/>
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Office Location <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
            {/* <Input
              type="select"
              onChange={(e) => setOfficeLocation(e.target.value)}
            >
              <option value="">select office location</option>
              {officeLocationList.map((officeLocationEl, i) => (
                <option
                  key={officeLocationEl.officeLocationId}
                  value={officeLocationEl.officeLocationId}
                  selected={
                    officeLocation === officeLocationEl.officeLocationId
                      ? true
                      : false
                  }
                >
                  {officeLocationEl.address}
                </option>
              ))}
            </Input> */}
            <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={officeLocationNewList[0]}
        onChange={(e) => {
          setOfficeLocation({value :e.value, label :e.label});
        }} 
       value={officeLocation}
        isSearchable={true}
        name="color"
        options={officeLocationNewList}
      />
            {/* when there is entry in FormValidation only render condition loop */}
            {Object.keys(formValidation).length !== 0 &&
              !formValidation.officeLocation.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.officeLocation.errorMessage}
                </span>
              )}
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Work premise <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
            {/* <Input
              type="select"
              onChange={(e) => setWorkPrimise(e.target.value)}
            >
              <option value="">select Work Premise</option>
              {workPrimisesList.map((workPrimisesEl, i) => (
                <option
                  key={workPrimisesEl.workingPremiseId}
                  value={workPrimisesEl.workingPremiseId}
                  selected={
                    workPrimise === workPrimisesEl.workingPremiseId
                      ? true
                      : false
                  }
                >
                  {workPrimisesEl.workingPremiseType}
                </option>
              ))}
            </Input> */}
             <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={workPrimisesNedwList[0]}
        onChange={(e) => {
          setWorkPrimise({value :e.value, label :e.label});
        }} 
       value={workPrimise}
        isSearchable={true}
        name="color"
        options={workPrimisesNedwList}
      />
            {/* when there is entry in FormValidation only render condition loop */}
            {Object.keys(formValidation).length !== 0 &&
              !formValidation.workPremise.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.workPremise.errorMessage}
                </span>
              )}
          </FormGroup>
        </Col>
      </Row>
      <hr></hr>
      <Row form>      
        <Col md={6}>
          <FormGroup>
          <Label>Shift <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
            
            <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={shiftListList[0]}
        onChange={(e) => {
          setShifts({value :e.value, label :e.label});
        }} 
       value={shifts}
        isSearchable={true}
        name="color"
        options={shiftListList}
      />
      
            {Object.keys(formValidation).length !== 0 &&
              !formValidation.shifts.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.shifts.errorMessage}
                </span>
              )}
            </FormGroup>
            </Col>
            <Col md={6}>
            <FormGroup>
          <Label>Assign Leave<i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
          {/* <Input
              type="select"
              onChange={(e) => setEmployee(e.target.value)}
            >
              <option value="">select</option>
              {AllempList.map((optinlist, i) => (
                <option
                  key={optinlist.empId}
                  value={optinlist.empId}
                  selected={
                    employee === optinlist.empId
                      ? true
                      : false
                  }
                >
                  {optinlist.label}
                </option>
              ))}
            </Input> */}
            <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={AllempNewList[0]}
        onChange={(e) => {
          setEmployee({value :e.value, label :e.label});
        }} 
       value={employee}
        isSearchable={true}
        name="color"
        options={AllempNewList}
      />
       {Object.keys(formValidation).length !== 0 &&
              !formValidation.employee.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.employee.errorMessage}
                </span>
              )}
          </FormGroup>
            </Col>
            </Row>
      <hr></hr>

      <Row form>      
        <Col md={6}>
          <FormGroup>
            <Label>UserName <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
            <Input type="text" onChange={(e) => checkUserName(e.target.value)} value={username} />
             {Object.keys(usernameCheck).length !== 0 && usernameCheck=="exists" &&(
                <span className=" " style={{ color: "red" }}>
                  {"Username already exists!"}
                </span>
              )}
              {Object.keys(formValidation).length !== 0 &&
              !formValidation.username.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.username.errorMessage}
                </span>
              )}
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            
            <Label>Password <i class="fa fa-star-of-life" style={{color:"#f91010",fontSize:"xx-small"}}></i></Label>
           <br/>
            <Input type={isRevealPwd ? "text" : "password"} onChange={(e) => setPassword(e.target.value)}
             value={password} autoComplete="new-password"/>
            <i className="iconlist" onClick={togglePasswordVisiblity}>{eye}</i>
            {Object.keys(formValidation).length !== 0 &&
              !formValidation.password.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.password.errorMessage}
                </span>
              )}
            
          </FormGroup>
        </Col>      
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup>
            <Label> Is Following Client Holiday</Label>
            <Input
                   className="calendaryearcheckboxedit"
                 
                  // style="margin-left: -126px !important;margin-top: 13px;"
                     type="checkbox"
                     onChange={(e) => {
                      setisclientholiday(e.target.checked);
                     }} 
                     checked={isclientholiday}
               
                     value={isclientholiday}  
                   />
                  
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col className="text-center">
          <Button
            color=""
            className="btn-admin-settings"
            // onClick={handleAddForm}
            onClick={formValidationOnSubmit}
          >
            {selectedEmployee ? "Update" : "Add"}
          </Button>
          &nbsp;
          <Button color="" className="btn-cancel" onClick={togglecancel}>
            Cancel
          </Button>
        </Col>
      </Row>
    </Form>
  );
});

export default EmployeeEditForm;
